import { Heading, Text } from '@cinch-labs/design-system'
import { storyblokEditable } from '@cinch-nx/data-storyblok'
import type { ContentSectionProps } from '@cinch-nx/landing-ui-shared'

import type { Delivery as DeliveryCollectSectionProps } from '../../types/about-us-page'
import styles from './delivery-collect.module.css'
import DeliveryOptionCard from './option-card'

export const DeliveryCollectSection: React.FC<DeliveryCollectSectionProps> = (
  blok,
) => {
  const { heading, body, options } = blok

  return (
    <section {...storyblokEditable(blok)} className={styles.wrapper}>
      <Heading className={styles.heading}>{heading}</Heading>

      <Text className={styles.body}>{body}</Text>

      <div className={styles.options}>
        {options?.map((option: ContentSectionProps) => (
          <DeliveryOptionCard {...option} key={option._uid} />
        ))}
      </div>
    </section>
  )
}

export default DeliveryCollectSection
